import { api } from "@/lib/api";
import { requirePermission } from "@/lib/permissions";
import type { PlannedAppointmentRow } from "./bulk-upload-plan";
import { resolveMissingUnits, type CreateMissingUnitsResult } from "./missing-units";

export type { CreateMissingUnitsResult };

export async function createMissingUnitsForPlan(rows: PlannedAppointmentRow[]): Promise<CreateMissingUnitsResult> {
  if (rows.length === 0) {
    return { resolvedRows: [], errors: [] };
  }

  await requirePermission("property_units.create");
  return resolveMissingUnits(rows, api.units.createMissing);
}
